import React, { useState, useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import {
  Btn,
  CustomDropdown,
  CustomModal,
  CustomPanel,
  InputNumeroInteiro,
  InputText,
  Loading,
  PageHeader,
} from '../../../../components'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { tableCellCentered } from '../../../../assets/js/styles'
import { errorHandler } from '../../../../services/util/error.service'
import { showMessageBox } from '../../../../store/actions/system.actions'
import {
  getUserActionGroups,
  getUsersActions,
  saveUserAction,
  saveUserActionGroup,
} from '../../../../services/api/https/system/system.http'

function Permissoes({ history, dispatch }) {
  // Vars
  const novoGrupo = { name: '' }
  const novaAcao = { action: '', action_group_id: '', show_ordem: '' }

  // Hooks
  const [isLoading, setIsLoading] = useState(true)
  const [acoes, setAcoes] = useState([])
  const [selectedAcao] = useState(novaAcao)
  const [showModalGrupo, setShowModalGrupo] = useState(false)
  const [showModalAcao, setShowModalAcao] = useState(false)
  useEffect(() => {
    getActions()
  }, [])
  // Events
  const onNovoGrupoClick = () => {
    setShowModalGrupo(true)
  }

  const onNovaAcaoClick = () => {
    setShowModalAcao(true)
  }

  const onModalGrupoAcoesClose = () => {
    setShowModalGrupo(false)
  }

  const onModalGrupoAcoesSuccess = group => {
    setShowModalGrupo(false)
  }

  const onModalGrupoAcoesError = error => {
    dispatch(showMessageBox(null, error))
    setShowModalGrupo(false)
  }

  const onModalAcaoClose = () => {
    setShowModalAcao(false)
  }

  const onModalAcaoSuccess = action => {
    getActions()
    setShowModalAcao(false)
  }

  const onModalAcaoError = error => {
    dispatch(showMessageBox(null, error))
    setShowModalAcao(false)
  }

  // Helpers
  const getActions = async () => {
    try {
      !isLoading && setIsLoading(true)
      const fetchedActions = await getUsersActions()
      setAcoes(fetchedActions)
    } catch (e) {
      dispatch(showMessageBox(null, errorHandler(e)))
    } finally {
      setIsLoading(false)
    }
  }
  // Render
  return (
    <React.Fragment>
      <PageHeader>S.0 - Permissões</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel showBtnNovo={false} onVoltar={history.goBack}>
          <div>
            <Btn onClick={onNovoGrupoClick}>Novo Grupo</Btn>
            <div style={{ display: 'inline-block', marginLeft: 10 }}>
              <Btn onClick={onNovaAcaoClick}>Nova Ação</Btn>
            </div>
          </div>
          <div style={{ marginTop: 10 }}>
            {isLoading ? (
              <div className="text-center">
                <Loading />
              </div>
            ) : (
              <DataTable
                value={acoes}
                rowGroupMode="subheader"
                groupField="group_name"
                rowGroupHeaderTemplate={acao => acao.group_name}
                rowGroupFooterTemplate={() => {}}
              >
                <Column field="user_action_id" header="Id" style={tableCellCentered(80)} />
                <Column field="action" header="Ação" />
                <Column field="show_ordem" header="Ordem" style={tableCellCentered()} />
              </DataTable>
            )}
          </div>
        </CustomPanel>
      </div>
      {showModalGrupo ? (
        <ModalGrupoAcoes
          grupo={novoGrupo}
          onModalClose={onModalGrupoAcoesClose}
          onModalError={onModalGrupoAcoesError}
          onModalSuccess={onModalGrupoAcoesSuccess}
        />
      ) : null}
      {showModalAcao ? (
        <ModalAcao
          acao={selectedAcao}
          onModalClose={onModalAcaoClose}
          onModalSuccess={onModalAcaoSuccess}
          onModalError={onModalAcaoError}
        />
      ) : null}
    </React.Fragment>
  )
}

function ModalGrupoAcoes({ grupo, onModalClose, onModalSuccess, onModalError }) {
  // Hooks
  const [selectedGrupo, setSelectedGrupo] = useState(grupo)

  // Events
  const onBtnSalvarClick = async () => {
    try {
      const group = await saveUserActionGroup(selectedGrupo.name)
      onModalSuccess(group)
      onModalSuccess(selectedGrupo)
    } catch (e) {
      onModalError(errorHandler(e))
    }
  }
  // Render
  return (
    <CustomModal
      isVisible={true}
      onClose={onModalClose}
      header={grupo.id ? 'Editando Grupo de Ações' : 'Novo Grupo de Ações'}
    >
      <div className="p-grid">
        <div className="p-col-12">
          <InputText
            marginTop={0}
            label="Nome :"
            value={selectedGrupo.name}
            onChange={name => setSelectedGrupo({ ...selectedGrupo, name })}
          />
        </div>
        <div className="p-col-12">
          <Btn onClick={onBtnSalvarClick}>Salvar</Btn>
        </div>
      </div>
    </CustomModal>
  )
}

function ModalAcao({ acao, onModalClose, onModalSuccess, onModalError }) {
  // Hooks
  const [isLoading, setIsLoading] = useState(false)
  const [isBtnSalvarLoading, setIsBtnSalvarLoading] = useState(false)
  const [action, setAction] = useState(acao)
  const [groups, setGroups] = useState([])
  useEffect(() => {
    getGroups()
  }, [])

  // Events
  const onBtnSalvarClick = async () => {
    try {
      const fetchedAction = await saveAction()
      onModalSuccess(fetchedAction)
    } catch (e) {
      onModalError(errorHandler(e))
    }
  }

  // Helpers
  const getGroups = async () => {
    try {
      !isLoading && setIsLoading(true)
      const fetchedGroups = await getUserActionGroups()
      const nGroups = fetchedGroups.map(g => ({ label: g.name, value: g.id }))
      setGroups(nGroups)
    } catch (e) {
      onModalError(errorHandler(e))
    } finally {
      setIsLoading(false)
    }
  }

  const saveAction = async () => {
    try {
      !isBtnSalvarLoading && setIsBtnSalvarLoading(true)
      return await saveUserAction(action)
    } catch (e) {
      onModalError(errorHandler(e))
    } finally {
      setIsBtnSalvarLoading(false)
    }
  }

  // Render
  return (
    <CustomModal
      isVisible={true}
      onClose={onModalClose}
      header={action.id ? 'Editando Ação' : 'Nova Ação'}
    >
      {isLoading ? (
        <div className="text-center">
          <Loading />
        </div>
      ) : (
        <div className="p-grid">
          <div className="p-col-12">
            <InputText
              marginTop={0}
              label="Ação :"
              value={action.action}
              onChange={value => setAction({ ...action, action: value })}
            />
          </div>
          <div className="p-col-6">
            <CustomDropdown
              label="Grupo:"
              value={action.action_group_id}
              onChange={id => setAction({ ...action, action_group_id: id })}
              options={groups}
              marginTop={0}
            />
          </div>
          <div className="p-col-6">
            <InputNumeroInteiro
              marginTop={0}
              label="Ordem de Exibição"
              value={action.show_ordem}
              onChange={value => setAction({ ...action, show_ordem: value })}
            />
          </div>
          <div className="p-col-12">
            <Btn onClick={onBtnSalvarClick}>Salvar</Btn>
          </div>
        </div>
      )}
    </CustomModal>
  )
}

export default connect()(withRouter(Permissoes))
